import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[calc(100vh-72px)] text-center px-4 pb-20 md:pb-[72px]">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="font-display text-xl md:text-2xl font-semibold mt-6 text-deep-ink">
          This page has not been created
        </h1>
        <p className="mt-2 text-base text-muted-umber font-mono">{location.pathname}</p>
        <Link
          to="/"
          className="inline-flex mt-8 font-body text-sm font-semibold text-parchment bg-deep-ink px-8 py-3 rounded-md hover:bg-amber transition-colors duration-300 whitespace-nowrap"
        >
          back home
        </Link>
      </div>
    </div>
  );
}